/* AutoGuard £100 off email sign-up — see snippets/bp-autoguard-offer.liquid */
(function () {
  var root = document.getElementById('bp-autoguard-offer');
  if (!root) return;
  if (Date.now() / 1000 > Number(root.getAttribute('data-ends'))) { root.style.display = 'none'; return; }
  var strip = root.querySelector('.bpago-strip');
  // Tap counter: one 'open' per browser session (counts people, not repeat taps).
  function track() {
    try {
      if (sessionStorage.getItem('bpago_open')) return;
      sessionStorage.setItem('bpago_open', '1');
      var url = root.getAttribute('data-endpoint') + '/event';
      var data = JSON.stringify({ event: 'open', page: location.pathname });
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([data], { type: 'text/plain' }));
      else fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: data, keepalive: true });
    } catch (e) {}
  }
  if (strip) strip.addEventListener('click', function () {
    var panel = document.getElementById('bpago-panel');
    var open = panel.hidden;
    panel.hidden = !open;
    strip.setAttribute('aria-expanded', open ? 'true' : 'false');
    strip.querySelector('.bpago-cta').innerHTML = open ? 'Close &#9652;' : 'Get code &#9662;';
    if (open) { var i = panel.querySelector('input[type=email]'); if (i) i.focus({ preventScroll: true }); }
    if (open) track();
  });
  var form = root.querySelector('.bpago-form');
  var done = root.querySelector('.bpago-done');
  var err = root.querySelector('.bpago-err');
  var btn = form.querySelector('button');
  function show(code) {
    form.hidden = true;
    done.hidden = false;
    done.querySelector('.bpago-code').textContent = code;
    var path = location.pathname.indexOf('/products/') === 0 ? location.pathname : '/products/ramco-auto-guard-battery-bollard';
    done.querySelector('.bpago-apply').href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path);
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    var email = form.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }
    btn.disabled = true; btn.textContent = 'One moment...';
    fetch(root.getAttribute('data-endpoint'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, consent: form.consent.checked, website: form.website.value, page: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.ok && d.code) { show(d.code); return; }
      err.textContent = (d && d.error) || 'Something went wrong. Please try again.'; err.hidden = false;
    }).catch(function () {
      err.textContent = 'Something went wrong. Please try again.'; err.hidden = false;
    }).then(function () { btn.disabled = false; btn.textContent = 'Reveal my code'; });
  });
})();
